import * as React from "react"
import {formatDate} from "@ui-seeker/utils";
import { Box } from "@mui/material";

import {BORDER_STYLE, BORDER_COLOR} from "@constants";


export default function daysDeliveryColumn(value, label) {
	return [{
		name: value, label: label,
		options: {
			display: 'excluded',
			customBodyRowRender: value => value ? `Has ${label}` : `No ${label}`
		}
	} , {
		name: value, label: label,
		options: {
			filter: false,
			setCellProps: () => ({ sx: { minWidth: 100, borderRight: BORDER_STYLE, borderColor: BORDER_COLOR }}),
			customBodyRowRenderLite: value => <Box>
				{!!value ? value : '--'}
			</Box>
		}
	}]
}
